import { Box, Grid, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Get } from "../config/apimethods/apimethods";
import { useEffect, useState } from "react";
import BAGrid from "../config/components/BAGrid";
import BAScreenHeader from "../config/components/BAScreenHeader";
import BAIconbutton from "../config/components/BAIconbutton";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { setDate } from "../config/core/helpermethod";
import BAShowError from "../config/components/BAShowerror";
import BALoader from "../config/components/BALoader";
import BAButton from "../config/components/BAButton";
import PaidStamp from '../assets/PaidStamp.png'
import BAModal from "../config/components/BAModal";

export default function ViewRecept() {
    const [model, setModel] = useState({})
    const [showMessage, setShowMessage] = useState(false)
    const [message, setMessage] = useState('')
    const [loader, setLoader] = useState(true)
    const [openModal, setOpenModal] = useState(false)
    const [paidLoader, setPaidLoader] = useState(false)
    const params = useParams()
    const navigate = useNavigate()
    const getRecept = (id) => {
        setLoader(true)
        Get('receipt', id).then(res => {
            if (!res.status) {
                setLoader(false)
                setMessage(res.errors)
                setShowMessage(true)
            } else {
                setLoader(false)
                setModel({ ...res.data })
            }
        }).catch(err => {
            setLoader(false)
            setMessage(err)
            setShowMessage(true)
        })
    }
    let payReciept = () => {
        setPaidLoader(true)
        Get('receipt/paid', null, { id: model._id }).then((res) => {
            console.log(res)
            setPaidLoader(false)
            if (res.status) {
                setMessage(res.message)
                setShowMessage(true)
                getRecept(params.id)
                setOpenModal(false)
            } else {
                setMessage(res.error)
                setShowMessage(true)
            }
        }).catch(err => {
            setPaidLoader(false)
            setMessage(err)
            setShowMessage(true)
        })
    }
    let printInvoice = () => {
        navigate("/printpage", { state: { model: model } });
    };
    useEffect(() => {
        if (params.id) {
            getRecept(params.id)
        }
    }, [])
    return <>
        <BAShowError message={message} open={showMessage} close={(e) => setShowMessage(e)} />
        <BAModal
            modalTitle="Are You Sure You want to marked as Paid this Reciept?"
            open={openModal}
            width='30vw'
            close={(e) => setOpenModal(e)}
            innerContent={<Box className='d-flex justify-content-around'>
                <BAButton onClick={() => setOpenModal(false)} color='warning' label='No' />
                <BAButton onClick={payReciept} label="Yes" />
            </Box>}
        />
        <Box>
            <BAScreenHeader title={`Reciept (${model.receiptNo})`} buttonsList={[
                {
                    displayField: <BAIconbutton onClick={printInvoice} icon={<LocalPrintshopIcon />} />
                },
                {
                    displayField: !model.isPaid && <BAButton loading={paidLoader} label='Pay Reciept' onClick={() => setOpenModal(true)} />
                },
            ]} />
            {loader ?
                <Box>
                    <BALoader />
                </Box>
                : <Box>
                    <Box className="p-2 rounded border">
                        <Grid container>
                            <Grid item sm={12} xs={12} md={3}>
                                <Box className='p-2 px-3'>
                                    <Typography className="fs-14 text-muted">Recipt Number</Typography>
                                    <Typography className="fs-6 fw-bold">{model.receiptNo}</Typography>
                                </Box>
                            </Grid>
                            <Grid sm={12} xs={12} md={3}>
                                <Box className='p-2 px-3'>
                                    <Typography className="fs-14 text-muted">Order Number</Typography>
                                    <Typography className="fs-6 fw-bold">{model.orderNo}</Typography>
                                </Box>
                            </Grid>
                            <Grid sm={12} xs={12} md={3}>
                                <Box className='p-2 px-3'>
                                    <Typography className="fs-14 text-muted">Customer Name</Typography>
                                    <Typography className="fs-6 fw-bold">{model.customerName}</Typography>
                                </Box>
                            </Grid>
                            <Grid sm={12} xs={12} md={3}>
                                <Box className='p-2 px-3'>
                                    <Typography className="fs-14 text-muted">Company Name</Typography>
                                    <Typography className="fs-6 fw-bold">{model.companyName}</Typography>
                                </Box>
                            </Grid>
                            <Grid sm={12} xs={12} md={3}>
                                <Box className='p-2 px-3'>
                                    <Typography className="fs-14 text-muted">Contact</Typography>
                                    <Typography className="fs-6 fw-bold">{model.contact}</Typography>
                                </Box>
                            </Grid>
                            <Grid sm={12} xs={12} md={3}>
                                <Box className='p-2 px-3'>
                                    <Typography className="fs-14 text-muted">City</Typography>
                                    <Typography className="fs-6 fw-bold">{model.city}</Typography>
                                </Box>
                            </Grid>
                            <Grid sm={12} xs={12} md={3}>
                                <Box className='p-2 px-3'>
                                    <Typography className="fs-14 text-muted">Due Date</Typography>
                                    <Typography className="fs-6 fw-bold">{setDate(model.dueDate)}</Typography>
                                </Box>
                            </Grid>

                            <Grid item md={3}>

                                <Box className="text-end">
                                    {model.isPaid && <img width="90px" src={PaidStamp} alt='paid' />}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className="py-2">
                        <BAGrid isGrouping={true} groupName='groupName' datasource={model.orderDetails} gridCols={[
                            {
                                label: 'Particular',
                                key: 'name',
                            },
                            {
                                label: 'Per Unit Value',
                                key: 'perUnitValue',
                            },
                            {
                                label: 'Quantity',
                                key: 'qty',
                            },
                            {
                                label: 'unit',
                                key: 'unit',
                            },
                            {
                                label: 'Amount',
                                key: 'amount',
                            },
                        ]} />
                    </Box>
                    <Grid container>
                        <Grid className="ms-auto" sm={12} xs={12} md={6}>
                            <Box className="p-2">
                                <table className="table table-striped">
                                    <tbody>

                                        <tr>
                                            <th>Amount</th>
                                            <td>{model.amount || 0}</td>
                                        </tr>
                                        <tr>
                                            <th>Discount</th>
                                            <td>{model.discount || 0}</td>
                                        </tr>
                                        <tr>
                                            <th>Final Amount</th>
                                            <td>{model.totalAmount || 0}</td>
                                        </tr>
                                        <tr>
                                            <th>Advance Amount</th>
                                            <td>{model.advanceAmount || 0}</td>
                                        </tr>
                                        <tr>
                                            <th>Balance</th>
                                            <td>{model.remainingAmount || 0}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>}
        </Box>
    </>
}